export const fileToDataURL = (file) => {
    return new Promise((resolve, reject) => {
        if (!file)
            reject(new Error("No file uploaded"));
        const reader = new FileReader();
        reader.addEventListener("load", () => {
            const dataURL = reader.result;
            resolve(dataURL);
        });
        reader.readAsDataURL(file);
    });
};
